<template>
	<div class="element el-map" :class="{ 'can-change': is_editable }">
		
		<div class="map" id="document-map"></div>

	</div>
</template>

<script>
import { mapGetters } from "vuex";
import L from "leaflet";
import ElementMixin from "@/components/study/editor/elements/element.mixin.js";

export default {
	name: "el-map",
	mixins: [ ElementMixin ],
	data: function () {
		return {
			map_osm: false,
			markers_layer: false
		};
	},
	props: [ "zoom", "center" ],
	computed: {
		...mapGetters([ ]),
	},
	methods: {
		init_map: function () {
			const self = this;
			const pin_coords = [this.active_study.geo.latitude, this.active_study.geo.longitude];
			const map_center = this.center;
			let zoom = 14;
			if (this.zoom) zoom = this.zoom;

			const GrayLight = L.tileLayer("http://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png", {
				attribution: "&copy; <a href=\"https://www.openstreetmap.org/copyright\">OpenStreetMap</a> contributors",
			});
			
			this.map_osm = L.map("document-map", {
				center: map_center,
				zoom: zoom,
				minZoom: 5,
				zoomControl: false,
				layers: [ GrayLight ]
			});

			this.map_osm.on("moveend", function () {
				self.$store.dispatch("edit_object", {
					obj: self.active_study.localisation_projet.map,
					field: "center",
					value: self.map_osm.getCenter()
				});
			});

			this.map_osm.on("zoomend", function () {
				self.$store.dispatch("edit_object", {
					obj: self.active_study.localisation_projet.map,
					field: "zoom",
					value: self.map_osm.getZoom()
				});
			});

			this.markers_layer = L.layerGroup().addTo(this.map_osm);

			const icon = L.divIcon({
				className: "map-icon expanded",
				html: "<div class=\"pin\"><div class=\"round\"></div></div>"
			});
			const marker = new L.marker(
				pin_coords,
				{ icon: icon, title: self.active_study.adresse + " " + self.active_study.ville }
			);
			marker.addTo(self.markers_layer);
		}
	},
	mounted: function () {
		this.$nextTick(function () {
			this.init_map();
		});
	}
};
</script>

<style lang="stylus" scoped>
@import '../../../../assets/css/app'
@import '../../../../assets/css/page'


.el-map
	display flex
	align-items center
	justify-content center
	height 250px
	background-color #eee
	font-size 24px
	color #999
	border-radius radius
	overflow hidden
	&.can-change
		box-shadow 0 0 0 1px purple
		&:after
			display none
	&:after
		content ''
		position absolute
		left 0
		top 0
		right 0
		bottom 0
		z-index 1000
	.map
		display block
		height 100%
		width 100%
		border none


</style>